import { combineReducers } from 'redux'

import courseTypeReducer from './course-type-reducer'
import courseTypesReducer from './course-types-reducer'

export default combineReducers({
  courseTypes: courseTypesReducer,
  courseType: courseTypeReducer,
})
